// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Wo1U","dragIcon":"Choice_dragIcon__3GAYM","left":"Choice_left__1WJfc","input":"Choice_input__1IBxj"};